import React from 'react';

import { Phone, Mail } from 'react-feather';
import { FaTelegramPlane } from 'react-icons/fa';

const ContactModal = (props) => (
    <div className="contact-modal">
        <div className="modal-body text-center">
            <h5 className="mb-3 pb-3 border-bottom font-weight-bold">{props.manager.name}</h5>
            <p><Phone size={22} className="pr-2" />{props.manager.phone}</p>
            <p><a href={`mailto:${props.manager.e_mail}`} ><Mail size={22} className="pr-2" />{props.manager.e_mail}</a></p>
            <p><a href={`https://t.me/${props.manager.im_handle}`}><FaTelegramPlane size={20} style={{ paddingRight: "5px" }} />Telegram</a></p>
            <div>
                <img className="w-100 rounded" src={`${props.manager.telegram_qr_code}`} alt="Telegram Code" />
            </div>
        </div>
    </div>
);

export default ContactModal;